export const MANAGER = 'MANAGER';
export const GET_MANAGERS_REQUEST = `${MANAGER}/getManagersRequest`;
export const UPDATE_MANAGER_REQUEST = `${MANAGER}/updateManagerRequest`;
export const REMOVE_MANAGER_REQUEST = `${MANAGER}/removeManagerRequest`;
